import { useRef } from 'react'

const DEFAULT_DELAY = 520

export function useLongPressMenu(onOpen, delay = DEFAULT_DELAY) {
  const timerRef = useRef(0)
  const openedRef = useRef(false)

  const clearTimer = () => {
    if (!timerRef.current) return
    window.clearTimeout(timerRef.current)
    timerRef.current = 0
  }

  const openMenu = (event) => {
    openedRef.current = true
    onOpen?.(event)
  }

  const consume = () => {
    if (!openedRef.current) return false
    openedRef.current = false
    return true
  }

  return {
    consume,
    onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return
      openedRef.current = false
      const snapshot = {
        currentTarget: event.currentTarget,
        clientX: event.clientX,
        clientY: event.clientY,
      }
      clearTimer()
      timerRef.current = window.setTimeout(() => {
        timerRef.current = 0
        openMenu(snapshot)
      }, delay)
    },
    onPointerUp: clearTimer,
    onPointerCancel: clearTimer,
    onPointerLeave: clearTimer,
    onContextMenu(event) {
      event.preventDefault()
      event.stopPropagation()
      clearTimer()
      openMenu(event)
    },
    onKeyDown(event) {
      if (event.key !== 'ContextMenu' && !(event.key === 'F10' && event.shiftKey)) return
      event.preventDefault()
      event.stopPropagation()
      clearTimer()
      openMenu(event)
    },
  }
}
